import { render, staticRenderFns } from "./TakeawayList.vue?vue&type=template&id=19c4114c&scoped=true&"
import script from "./TakeawayList.vue?vue&type=script&lang=js&"
export * from "./TakeawayList.vue?vue&type=script&lang=js&"
import style0 from "./TakeawayList.vue?vue&type=style&index=0&id=19c4114c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4114c",
  null
  
)

export default component.exports